import { useMutation, useQueryClient } from "@tanstack/react-query";
import api from "../../http";
import { getApiErrorMessage, toApiError } from "../utils";

export const useDeleteFertilizer = () => {
    const queryClient = useQueryClient();
    return useMutation({
        mutationFn: async (id: string) => {
            try {
                return (await api.delete(`/products/fertilizer/delete/${id}`)).data;
            } catch (error) {
                throw toApiError(error, 'Erro ao deletar fertilizante');
            }
        },
        onSuccess: () => queryClient.invalidateQueries({ queryKey: ['fertilizers'] }),
        onError: error => console.error('Erro ao deletar fertilizante:', getApiErrorMessage(error, 'Erro ao deletar fertilizante'))
    });
};
